import { Button, FormControl, FormLabel, Grid, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea } from '@chakra-ui/react'

interface Props {
	isOpen: boolean
	onClose: () => void
}

const AddNote = ({ isOpen, onClose }: Props) => {
	return (
		<Modal onClose={onClose} isOpen={isOpen} isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Adicionar Nota</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Grid
						w="full"
						templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
						gap="12px"
					>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Título
							</FormLabel>
							<Input
								borderRadius="8px"
								fontSize="md"
							/>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Descrição
							</FormLabel>
							<Textarea
								borderRadius="8px"
								fontSize="md"
							/>
						</FormControl>
					</Grid>
				</ModalBody>
				<ModalFooter>
					<HStack spacing={4}>
						<Button variant="ghost" onClick={onClose}>Cancelar</Button>
						<Button colorScheme="green" onClick={onClose}>Adicionar</Button>
					</HStack>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default AddNote
